import { PayloadsType } from '../utils/types';

export const Name = 'landing-page-hero-question';

export enum PayloadType {
  NursingArea = 'nursing-area',
  EmployeeType = 'employee-type',
}

export const Payloads: PayloadsType<PayloadType> = {
  control: PayloadType.NursingArea,
  test: PayloadType.EmployeeType,
};
